// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { ROAD_NETWORK_GROUPS, IRoadNetworkGroup } from 'Utils/constants';

export interface IRoadNetworkGroupPresent extends IRoadNetworkGroup {
  present: string[]; // the group's classes the area actually has
}

// The groups to show for an area, in dialog order: those with at least one class in the Lambda's list.
export const roadNetworkGroups = (availableClasses: string[]): IRoadNetworkGroupPresent[] => {
  const withPresent = ROAD_NETWORK_GROUPS.map((group) => ({ ...group, present: group.classes.filter((c) => availableClasses.includes(c)) }));
  return withPresent.filter((group) => group.present.length > 0);
};

export const defaultCheckedKeys = (groups: IRoadNetworkGroupPresent[]): string[] => groups.filter((g) => g.defaultChecked).map((g) => g.key);

// What the pull sends as roadTypes: the present classes of the checked groups, in group order.
export const classesOfCheckedGroups = (groups: IRoadNetworkGroupPresent[], checkedKeys: string[]): string[] =>
  groups.filter((g) => checkedKeys.includes(g.key)).reduce<string[]>((classes, g) => classes.concat(g.present), []);
